var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as Types from '../../types';
import { fxView } from './lib/fxView.cls';
import * as fxViewStoreExtensions from './provider/candle-history';
var state = __assign({}, fxViewStoreExtensions.stateExt);
var actions = __assign({}, fxViewStoreExtensions.actionsExt);
var mutations = __assign({}, fxViewStoreExtensions.mutationsExt);
var getters = __assign({}, fxViewStoreExtensions.gettersExt);
var fxViewStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var fxViewMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[fxView.STORE_MODULE_NAME])) {
            this.$store.registerModule(fxView.STORE_MODULE_NAME, fxViewStore);
        }
    },
    methods: __assign({}, mapActions({
        //admin
        _runGetAdminList: Const.RUN_GET_ADMIN_LIST,
        _runGetAdminDetail: Const.RUN_GET_ADMIN_DETAIL,
        _runAddAdmin: Const.RUN_ADD_ADMIN,
        _runUpdateAdminDetail: Const.RUN_UPDATE_ADMIN_DETAIL,
        //client admin
        _runVerifyAdmin: Const.RUN_VERIFY_ADMIN,
        _runDisableAdmin: Const.RUN_DISABLE_ADMIN,
        _runVerifyClient: Const.RUN_VERIFY_CLIENT,
        _runDisableClient: Const.RUN_DISABLE_CLIENT,
        _runDisableAccount: Const.RUN_DISABLE_ACCOUNT,
        _runGetDashboardData: Const.RUN_GET_DASHBOARD_DATA,
        _runGetDashboardOtherData: Const.RUN_GET_DASHBOARD_OTHER_DATA,
        _runGetTotalSubIb: Const.RUN_GET_TOTAL_SUBIB,
        _runGetTotalDeeposit: Const.RUN_GET_TOTAL_DEPOSIT,
        _runGetTotalWithdrawal: Const.RUN_GET_TOTAL_WITHDRAWAL,
        _runGetTotalClient: Const.RUN_GET_TOTAL_CLIENT,
        //client
        _runCreateClient: Const.RUN_CREATE_CLIENT,
        _runGetUserList: Const.RUN_GET_USER_LIST,
        _runUpdateClientDetail: Const.RUN_UPDATE_CLIENT_DETAIL,
        _runGetUserView: Const.RUN_GET_USER_VIEW,
        _runResetPassword: Const.RUN_RESET_PASSWORD,
        //client
        _runUserSubIbList: Const.RUN_GET_SUBIB_LIST,
        // master
        _runMasterList: Const.RUN_GET_MASTER_LIST,
        _runMasterDetail: Const.RUN_GET_MASTER_DETAILS,
        _runMasterUpdate: Const.RUN_UPDATE_MASTER_DETAILS,
        //logs
        _runGetLogsList: Const.RUN_GET_LOGS_LIST,
        _rundisable2fa: Const.RUN_DISABLE2FA,
        //Commission
        _runGetCommissionList: Const.RUN_GET_COMMISSION_LIST,
        _runGetCommissionView: Const.RUN_GET_COMMISSION_VIEW,
        _runAddCommissionUpdate: Const.RUN_GET_COMMISSION_UPDATE,
        //bonus
        _runGetBonusList: Const.RUN_GET_BONUS_LIST,
        _runGetBonusView: Const.RUN_GET_BONUS_VIEW,
        _runAddBonusUpdate: Const.RUN_GET_BONUS_UPDATE,
        _runAddCreateBonus: Const.RUN_ADD_BONUS,
        _runAddManualBonus: Const.RUN_ADD_MANUAL_BONUS,
        _rundisableBonus: Const.RUN_GET_BONUS_DISABLE,
        //deposit
        _runCreateDeposit: Const.RUN_CREATE_DEPOSIT,
        _runGetDepositList: Const.RUN_GET_DEPOSIT_LIST,
        _runGetDepositView: Const.RUN_GET_DEPOSIT_VIEW,
        _runEditDepositDetails: Const.RUN_EDIT_DEPOSIT_DETAILS,
        _runGetDepositTransaction: Const.RUN_GET_DEPOSIT_TRANSACTION,
        //trading
        _runGetTradingList: Const.RUN_GET_TRADING_LIST,
        _runGetTradingView: Const.RUN_GET_TRADING_VIEW,
        _runEditTradingDetails: Const.RUN_EDIT_TRADING_DETAILS,
        _rundisableTradingAccount: Const.RUN_DISABLE_TRADING_ACCOUNT,
        _runChangeLeverage: Const.RUN_CHANGE_LEVERAGE,
        _runChangeAccountType: Const.RUN_ACCOUNT_CHANGE,
        //ticket
        _runCloseTicket: Const.RUN_CLOSE_TICKET,
        _runGetTicketView: Const.RUN_GET_TICKET_VIEW,
        _runTicketReply: Const.RUN_TICKET_REPLY,
        _runAddTicket: Const.RUN_ADD_TICKET,
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        //withdrawal
        _runGetWithdrawalList: Const.RUN_GET_WITHDRAWAL_LIST,
        _runEditWithdrawalDetails: Const.RUN_EDIT_WITHDRAWAL_DETAILS,
        _runGetAccountDetails: Const.RUN_GET_ACCOUNT_DETAIL,
        _runAddWithdrawal: Const.RUN_ADD_WITHDRAWAL,
        _runGetWithdrawalView: Const.RUN_GET_WITHDRAWAL_VIEW,
        //request Access
        _runRequestOtp: Const.RUN_REQUEST_OTP,
        _runVerifyOtp: Const.RUN_VERIFY_OTP,
        // not found working
        //===================static variable fetch from database============================
        _runGetCountriesList: Const.RUN_GET_COUNTRIES_LIST,
        _runGetCitiesList: Const.RUN_GET_CITIES_LIST,
        _runCallUser: Const.CALL_USER,
        //report
        _runGetReportingList: Const.RUN_GET_REPORTING_LIST,
        _runCreateReport: Const.RUN_CREATE_REPORT,
        //coupon
        _runGetCouponList: Const.RUN_GET_COUPON_LIST,
        _runCreateCoupon: Const.RUN_CREATE_COUPON,
        _runSubExistsList: Const.RUN_SUB_EXSIST_LIST,
        _runSubPlanList: Const.RUN_SUB_PLAN_LIST,
        _runSubPlanDetail: Const.RUN_SUB_PLAN_DETAIL,
        _runSubOper: Const.RUN_SUB_OPER,
        _runGetPlanCouponList: Const.RUN_GET_PLAN_COUPON_LIST,
        _runUnsubscribe: Const.RUN_UNSUBSCRIBE,
        //email
        _runEmailSettingList: Const.RUN_EMAIL_SETTING_LIST,
        _runAddEmailSetting: Const.RUN_ADD_EMAIL_SETTING,
        //client
        _runGetLogsView: Const.RUN_GET_LOGS_VIEW,
        _runGetLogsDetail: Const.RUN_GET_LOGS_DETAIL,
        _runUserCount: Const.RUN_USER_COUNT,
        _runUserNotification: Const.RUN_USER_NOTIFICATIONS,
        _runGetInternalNotes: Const.RUN_GET_INTERNAL_NOTES,
        _runAddInternalNotes: Const.RUN_ADD_INTERNAL_NOTES,
        _runVerifyAccount: Const.RUN_VERIFY_ACCOUNT,
        _runGetRiskMetrix: Const.RUN_GET_RISK_METRIX,
        _runCreateTradingAccount: Const.RUN_CREATE_TRADING_ACCOUNT,
        //faq
        _runCreateCategory: Const.RUN_CREATE_CATEGORY,
        _runCreateArticle: Const.RUN_CREATE_ARTICLE,
        _runGetCatList: Const.RUN_GET_CAT_LIST,
        _runGetArticleList: Const.RUN_GET_ARTICLE_LIST,
        _runGetCatDetail: Const.RUN_GET_CAT_DETAIL,
        _runGetArticleDetail: Const.RUN_GET_ARTICLE_DETAIL,
        //deposit
        _runGetTransactionStatus: Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS,
        //ticket
        _runTicketReasonList: Const.RUN_TICKET_REASON_LIST,
        _runTicketApprove: Const.RUN_TICKET_APPROVE,
        _runTicketDocApproveReject: Const.RUN_TICKET_DOC_APPROVE_REJECT,
        _runTicketTransfer: Const.RUN_TICKET_TRANSFER,
        //withdrawal
        _runWithdrawalMethods: Const.RUN_WITHDRAWAL_METHODS,
        /*_runDeleteTradingAccount		                :   			Const.RUN_DELETE_TRADING_ACCOUNT,*/
        _runGetNotificationListing: Const.RUN_GET_NOTIFICATION_LISTING,
        //document api
        _runDocumentLinkApi: Const.RUN_DOCUMENT_LINK_API,
        //contact us
        _runContactUs: Const.RUN_CONTACT_US,
        _runGetContactUs: Const.RUN_GET_CONTACT_US,
        //enabel disable internal trasfer
        _runEnableDesableTransfer: Const.RUN_ENABLE_DESABLE_TRANSFER,
        // bonus booster campaigns
        _runBBCampaignList: Const.RUN_BB_CAMPAIGN_LIST,
        _runBBCampaignCreate: Const.RUN_BB_CAMPAIGN_CREATE,
        _runBBCampaignGet: Const.RUN_BB_CAMPAIGN_GET,
        _runBBCampaignUpdate: Const.RUN_BB_CAMPAIGN_UPDATE,
        _runBBCampaignToggle: Const.RUN_BB_CAMPAIGN_TOGGLE,
        // bonus booster codes
        _runBBCodeList: Const.RUN_BB_CODE_LIST,
        _runBBCodeCreate: Const.RUN_BB_CODE_CREATE,
        _runBBCodeBulk: Const.RUN_BB_CODE_BULK,
        _runBBCodeUpdate: Const.RUN_BB_CODE_UPDATE,
        _runBBCodeToggle: Const.RUN_BB_CODE_TOGGLE,
        // bonus booster redemptions
        _runBBRedemptionList: Const.RUN_BB_REDEMPTION_LIST,
        _runBBRedemptionGet: Const.RUN_BB_REDEMPTION_GET,
        _runBBRedemptionApprove: Const.RUN_BB_REDEMPTION_APPROVE,
        _runBBRedemptionReject: Const.RUN_BB_REDEMPTION_REJECT,
    }), { redirect: function (getPageName, getId, getParams, getVerifiedStatus, getPageType) {
            var routeData;
            var inputJson = {
                name: getPageName,
                query: {}
            };
            if (getId != '' && getId != null && getId != undefined) {
                inputJson.query['id'] = getId;
            }
            if (getVerifiedStatus != '' && getVerifiedStatus != null && getVerifiedStatus != undefined) {
                inputJson.query['getVerifiedStatus'] = getVerifiedStatus;
            }
            if (getParams != '' && getParams != null && getParams != undefined) {
                inputJson.query['userId'] = getParams;
            }
            if (getPageType != '' && getPageType != null && getPageType != undefined) {
                this.$router.replace(inputJson);
            }
            else {
                routeData = this.$router.resolve(inputJson);
                window.open(routeData.href, '_blank');
            }
        },
        handleValidationErrorAdvanced: function (getErrors) {
            var firstField = Object.keys(getErrors.collect())[0];
            this.$refs[firstField + "Input"].focus();
            return this.$refs[firstField + "Input"].scrollIntoView();
        },
        setData: function (getTitleName) {
            this.$parent.pageTitle = getTitleName;
            this.$parent.message = '';
            this.$parent.message_type = '';
        },
        computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        permissionModule: function (getData, getpara) {
            //let perList = this.$store.getters[Types.GET_USER];
            //perList = perList.permissions.split(',')
            return true;
            /*if(perList.indexOf(getData) >= 0){
                return true ;
            }else if(getpara == 'view'){
                return false;
            }else{
                this.$router.replace({name: 'noFound'})
            }*/
        },
        serviceFunction: function (planId, detailId) {
            var sub_array = this.subExistList, count = 0;
            if (detailId != '' && detailId != null) {
                if (sub_array.length > 0) {
                    for (var i = 0; i <= sub_array.length - 1; i++) {
                        if ((parseInt(sub_array[i].plan_id) == parseInt(planId)) && (parseInt(sub_array[i].pdetail_id) == parseInt(detailId))) {
                            count = 1;
                        }
                        if (i == sub_array.length - 1) {
                            if (count == 1) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                }
                else {
                    return false;
                }
            }
            else {
                if (sub_array.length > 0) {
                    var count1 = 0;
                    for (var j = 0; j <= sub_array.length - 1; j++) {
                        if (parseInt(sub_array[j].plan_id) == parseInt(planId)) {
                            count1 = 1;
                        }
                        if (j == sub_array.length - 1) {
                            if (count1 == 1) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                    }
                }
                else {
                    return true;
                }
            }
        } }),
    computed: {
        countriesList: function () { return this.computedCommonFunc(Const.GET_COUNTRIES_LIST); },
        contact_us: function () { return this.computedCommonFunc(Const.GET_CONTACT_US); },
        citiesList: function () { return this.computedCommonFunc(Const.GET_CITIES_LIST); },
        referLinks: function () { return this.computedCommonFunc(Const.RUN_GET_REFER_LINKS); },
        //coupon
        couponList: function () { return this.computedCommonFunc(Const.GET_COUPON_LIST); },
        subExistList: function () { return this.computedCommonFunc(Const.GET_SUB_EXSIST_LIST); },
        subPlanList: function () { return this.computedCommonFunc(Const.GET_SUB_PLAN_LIST); },
        subPlanDetail: function () { return this.computedCommonFunc(Const.GET_SUB_PLAN_DETAIL); },
        //reporting
        reportingList: function () { return this.computedCommonFunc(Const.GET_REPORTING_LIST); },
        emirList: function () { return this.computedCommonFunc(Const.GET_EMIR_LIST); },
        //admin
        adminList: function () { return this.computedCommonFunc(Const.GET_ADMIN_LIST); },
        adminDetail: function () { return this.computedCommonFunc(Const.GET_ADMIN_DETAIL); },
        //email
        emailList: function () { return this.computedCommonFunc(Const.GET_EMAIL_SETTING_LIST); },
        //client
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        withdrawalMethodResponse: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE); },
        ibList: function () { return this.computedCommonFunc(Const.GET_SUBIB_LIST); },
        userList: function () { return this.computedCommonFunc(Const.GET_USER_LIST); },
        logsList: function () { return this.computedCommonFunc(Const.GET_LOGS_LIST); },
        logsView: function () { return this.computedCommonFunc(Const.GET_LOGS_VIEW); },
        userView: function () { return this.computedCommonFunc(Const.GET_USER_VIEW); },
        userCount: function () { return this.computedCommonFunc(Const.GET_USER_COUNT); },
        riskMetrix: function () { return this.computedCommonFunc(Const.GET_RISK_METRIX); },
        articleList: function () { return this.computedCommonFunc(Const.GET_ARTICLE_LIST); },
        catList: function () { return this.computedCommonFunc(Const.GET_CAT_LIST); },
        empStatus: function () { return this.computedCommonFunc(Const.GET_EMP_STATUS); },
        occupation: function () { return this.computedCommonFunc(Const.GET_OCCUPATION); },
        estYearlyIncome: function () { return this.computedCommonFunc(Const.GET_EST_YEARLY_INCOME); },
        estNetWorth: function () { return this.computedCommonFunc(Const.GET_EST_NET_WORTH); },
        antAccountTurnover: function () { return this.computedCommonFunc(Const.GET_ACCOUNT_TURNOVER); },
        genderList: function () { return this.computedCommonFunc(Const.GET_GENDER_LIST); },
        internalNotesList: function () { return this.computedCommonFunc(Const.GET_INTERNAL_NOTES); },
        roleList: function () { return this.computedCommonFunc(Const.GET_ROLE_LIST); },
        idenVerList: function () { return this.computedCommonFunc(Const.GET_IDEN_VER); },
        fundSrcList: function () { return this.computedCommonFunc(Const.GET_FUND_SRC); },
        deptMethdList: function () { return this.computedCommonFunc(Const.GET_DEPT_METHD); },
        credInsList: function () { return this.computedCommonFunc(Const.GET_CRED_INS); },
        chnlRiskList: function () { return this.computedCommonFunc(Const.GET_CHNL_RSK); },
        thrdPartyList: function () { return this.computedCommonFunc(Const.GET_THRD_PARTY); },
        stepList: function () { return this.computedCommonFunc(Const.GET_STEP); },
        timeZone: function () { return this.computedCommonFunc(Const.GET_TIMEZONE); },
        //deposit
        depositList: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIST); },
        depositTransaction: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_TRANSACTION); },
        depositView: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_VIEW); },
        depositStatus: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_STATUS); },
        depositMethod: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_METHOD); },
        //bonus
        bonusList: function () { return this.computedCommonFunc(Const.GET_BONUS_LIST); },
        bonusView: function () { return this.computedCommonFunc(Const.GET_BONUS_VIEW); },
        //commission
        commissionList: function () { return this.computedCommonFunc(Const.GET_COMMISSION_LIST); },
        commissionView: function () { return this.computedCommonFunc(Const.GET_COMMISSION_VIEW); },
        //ticket
        ticketList: function () { return this.computedCommonFunc(Const.GET_TICKET_LIST); },
        ticketView: function () { return this.computedCommonFunc(Const.GET_TICKET_VIEW); },
        ticketDocs: function () { return this.computedCommonFunc(Const.GET_TICKET_DOCS); },
        ticketDocsLink: function () { return this.computedCommonFunc(Const.GET_TICKET_DOCS_LINK); },
        //zip
        getzipdoclink: function () { return this.computedCommonFunc(Const.GET_ZIP_DOCS_LINK); },
        ticketStatus: function () { return this.computedCommonFunc(Const.GET_TICKET_STATUS); },
        ticketReason: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON); },
        departmentList: function () { return this.computedCommonFunc(Const.GET_DEPARMENT_LIST); },
        ticketReasonList: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST); },
        //withdrawal
        withdrawalList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST); },
        withdrawalView: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_VIEW); },
        withdrawalType: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_TYPE); },
        withdrawalMethods: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHODS); },
        withdrawalMethod: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD); },
        withdrawalStatus: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_STATUS); },
        //trading
        tradingList: function () { return this.computedCommonFunc(Const.GET_TRADING_LIST); },
        tradingView: function () { return this.computedCommonFunc(Const.GET_TRADING_VIEW); },
        demoLive: function () { return this.computedCommonFunc(Const.GET_DEMO_LIVE); },
        currency: function () { return this.computedCommonFunc(Const.GET_CURRENCY); },
        //bonus
        bonusType: function () { return this.computedCommonFunc(Const.GET_BONUS_TYPE); },
        bonusStatus: function () { return this.computedCommonFunc(Const.GET_BONUS_STATUS); },
        notificationListing: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_LISTING); },
        // bonus booster
        bonusBoosterCampaigns: function () { return this.computedCommonFunc(Const.GET_BB_CAMPAIGN_LIST); },
        bonusBoosterCampaignDetail: function () { return this.computedCommonFunc(Const.GET_BB_CAMPAIGN_DETAIL); },
        bonusBoosterCodes: function () { return this.computedCommonFunc(Const.GET_BB_CODE_LIST); },
        bonusBoosterCodeDetail: function () { return this.computedCommonFunc(Const.GET_BB_CODE_DETAIL); },
        bbRedemptions: function () { return this.computedCommonFunc(Const.GET_BB_REDEMPTION_LIST); },
        bbRedemptionDetail: function () { return this.computedCommonFunc(Const.GET_BB_REDEMPTION_DETAIL); },
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/index.ts
// module id = null
// module chunks = 